<style scoped lang="scss"></style>


<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/qunlong/mould/queryPage" getKey="rows"
      :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">

          <el-form-item :label="$t('mujubianhao')">
            <el-input v-model="yt.conditions.mouldNumber"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>

          <el-form-item :label="$t('jimopeichanpin')">
            <!-- 跨组件 - 物料信息 -->
            <yi_cross_select multiple :component="'web_base_matter_list'" :min="1" :ids.sync="yt.conditions.materialIds">
            </yi_cross_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('shezhitongjiguize', null, 'w1')" type="primary">
          {{ $t('shezhitongjiguize') }}
        </el-button>
      </template>
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
          @click="yt.showColumnsDialog()"></el-button>
      </template>


      <template #shuikouzhong="scope">
        <span :style="{ color: waterMouthHighLight(scope.row) ? 'red' : '' }"> {{
          scope.row.firstCheckGrossWeight == null || scope.row.firstCheckNetWeight == null?'':parseFloat(scope.row.firstCheckGrossWeight - scope.row.firstCheckNetWeight).toFixed(2)
        }}</span>
      </template>

      <template #shijixingqiangshu="scope">
        <span :style="{ color: actualCavityHighLight(scope.row) ? 'red' : '' }"> {{ scope.row.firstCheckRealmouldQty }}</span>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <el-form :inline="true" ref="form" size="mini" label-width="auto" :rules="rules" :model="form">
        <el-form-item :label="$t('gaoliangduxuelv')" prop="blockingRate">
          <el-input-number v-model="form.blockingRate" :min="0" :max="100" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('gaoliangshuikouzhong')" prop="waterMouthRate">
          <el-input-number v-model="form.waterMouthRate" :min="0" :max="100" :controls="false"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button :loading="store.state.global_loading" size="mini" @click="setLocalStorageParams" type="primary">
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script type="text/javascript">

export default {
  name: "web_mold_management_params_record_list",
  data() {
    var validate = (rule, value, callback) => {
      let reg = /^[0-9]\d*$/
      if (value === undefined || !reg.test(value) || value > 100) {
        return callback(new Error('请输入大于等于0小于100的正整数'))
      }
    };
    return {
      rules: {
        blockingRate: [{
          required: true, trigger: 'blur', validator: validate
        }],
        waterMouthRate: [{
          required: true, trigger: 'blur', validator: validate
        }],
      },
      form: {
        blockingRate: 100,
        waterMouthRate: 100
      },
      columns: [
        {
          label: 'mojubianhao',
          prop: 'mouldNumber',
        },
        {
          label: 'mojumingcheng',
          prop: 'name',
        },
        {
          label: 'biaozhunxingqiangshu',
          prop: 'mouldQty',

        },
        {
          label: 'shijixingqiangshu',
          prop: 'firstCheckRealmouldQty',
          type: 'slot'
        },
        {
          label: 'jingmozhong',
          prop: 'firstCheckNetWeight',
        },
        {
          label: 'shuikouzhong',
          type: 'slot'
        },
        {
          label: 'momaozhong',
          prop: 'firstCheckGrossWeight',
        },
        {
          label: 'xiugaishijian',
          prop: 'modifyDate',
          type: 'time',
        },
      ]
    }
  }, methods: {

    actualCavityHighLight(row) {
      let firstCheckRealmouldQty = row.firstCheckRealmouldQty
      let mouldQty = row.mouldQty
      return (100 - (firstCheckRealmouldQty / mouldQty) * 100) >= this.form.blockingRate
    },

    waterMouthHighLight(row) {
      let firstCheckGrossWeight = row.firstCheckGrossWeight
      let firstCheckNetWeight = row.firstCheckNetWeight
      return ((firstCheckGrossWeight - firstCheckNetWeight) / firstCheckGrossWeight) * 100 >= this.form.waterMouthRate
    },

    setLocalStorageParams() {

      localStorage.setItem("mold_high_light_params", JSON.stringify(this.form))
      this.yt.isShowEditDialog = false
      setTimeout(() => {
        this.yt.get(1)
      }, 300)
    },

    exportExcel() {
      let params = this.yt.conditions
      params.pageSize = this.yt.pageSize
      params.pageNum = this.yt.pageNum
      return this.http.get('/web/report/export/qunlong_mould_params_record_export', {
        params
      }).then(res => {
        this.$message.success(this.$t(res.msg))
        this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
      }).catch(error => {
        this.$message.error(this.$t(error))
      })
    },

  }, mounted() {

  }, created() {
    let cacheParams = localStorage.getItem("mold_high_light_params")
    if (cacheParams) {
      this.form = JSON.parse(cacheParams)
      console.log(this.form)
    }
    setTimeout(() => {
      this.yt.get(1);
    }, 300)

  }
}
</script>